import Vue from 'vue';
import Vuex from 'vuex';
import {getCache} from "@/utils/useCache";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        activeIndex: getCache('CURRENT_MENU'),
        ruleForm: {
            age: '',
            sex: null,
            main: null,
            dnas: [],
            ills: [],
            illname: '',
            yellow: null,
            eyes: null,
            heart: null,
            blood: null,
            ldlc: '',
            tgtime: ''
        },
        ruleFormu: {
            age: '',
            sex: null,
            main: null,
            dnas: [],
            ills: [],
            illname: '',
            heart: null,
            blood: null,
            ldlc: '',
            tgtime: ''
        },
        showDNA: false,
        showIll: false,
        showDNAu: false,
        showIllu: false,
    },
    mutations: {
        setRuleForm(state, payload) {
            state.ruleForm = payload;
        },
        setRuleFormu(state, payload) {
            state.ruleFormu = payload;
        },
        setShowDNA(state, payload) {
            state.showDNA = payload;
        },
        setShowIll(state, payload) {
            state.showIll = payload;
        },
        setShowDNAu(state, payload) {
            state.showDNAu = payload;
        },
        setShowIllu(state, payload) {
            state.showIllu = payload;
        },
    },
    actions: {
        updateRuleForm({commit}, payload) {
            commit('setRuleForm', payload);
        },
        updateRuleFormu({commit}, payload) {
            commit('setRuleFormu', payload);
        }
    },
    getters: {
        getRuleForm: state => state.ruleForm,
        getRuleFormu: state => state.ruleFormu
    }
});